import { useRef,useEffect } from 'react';
import { useResetRecoilState } from 'recoil';
import { namespaceState,selectedTaskState,newTaskConfig } from '../../recoil/atoms';
import logoMotion from '../../assets/logo_motion.mp4';
import styles from './style.module.css';
import useApi from '../../services/useApi';
import uuidV4 from '../../utils/uuidV4';
import NaviButton from '../../compoenets/NaviButton';

export default function Landing() {
  const landingLogo=useRef(null);
  const resetNsState=useResetRecoilState(namespaceState);
  const resetTaskState=useResetRecoilState(selectedTaskState);
  const resetTaskConfig=useResetRecoilState(newTaskConfig);

  useEffect(() => {
    if(landingLogo.current.played.length === 0 ) landingLogo.current.play();
    resetNsState();
    resetTaskState();
    resetTaskConfig();

    const timer = setInterval(() => {
      let landingLogoPlay=landingLogo.current.play();
      if (landingLogoPlay !== undefined) { landingLogoPlay.then((_) => {}).catch((error) => {}); }
    }, 8000);
    return () => {
      clearInterval(timer);
    };
  }, []);

  const handleSignIn=()=>{
    useApi.get('ngp/oauth/key/1').then((res)=>{
      if (res.status === 200) {
        let resData = res.data;
        let redirectUrl = resData.loginUri +
            "?client_id=" + resData.clientId +
            "&redirect_uri=" + resData.redirectUri +
            "&response_type=" + resData.responseType +
            "&scope=" + resData.scope +
            "&nonce=" + uuidV4();
        window.location.href = redirectUrl 
      } else {
          alert('SSO 로그인 실패, 관리자에게 연락바랍니다.')
      }
    })
    .catch(async (err) => {
      console.log(err)
      alert('서버연결 실패, 관리자에게 연락바랍니다.')
    })
  }

  return (
      <div className={styles["Landing-wrap"]}>
        <video ref={landingLogo} muted className={styles["Landing-logo"]}>
          <source src={logoMotion} type="video/mp4"/>
        </video>
        <div className={styles["Landing-title"]}>
          <p className={styles["Landing-title-main"]}>
            SAMUEL
          </p>
          <p className={styles["Landing-title-sub"]}>
            Federated Learning<br></br>Workspace
          </p>
          <div className={styles['Landing-btn-wrap']}>
            <div className={`${styles["Landing-btn"]} ${styles["Landing-btn-signIn"]}`} onClick={handleSignIn}>Sign In</div>
            <NaviButton to="/sign-up" className={`${styles["Landing-btn"]} ${styles["Landing-btn-signUp"]}`}>Sign Up</NaviButton>
          </div>
        </div>
      </div>
  );
}